import { useEffect, useState } from "react";
import CollectorMap from "../../components/ui/map/CollectorMap";
import Copyright from "../../components/ui/labels/Copyright";
import DevModeLabel from "../../components/ui/labels/DevModeLabel";
import FullScreenActivityIndicator from "../../components/ui/activityIndicator/FullScreenActivityIndicator";
import Logo from "../../components/ui/labels/Logo";
import ProjectLabel from "../../components/ui/labels/ProjectLabel";
import SectionHeader from "../../components/ui/labels/SectionHeader";
import StatusPrompt from "../../components/ui/prompts/StatusPrompt";
import useLocation from "../../hooks/useLocation";

const Home = () => {
  // State.
  const [status, setStatus] = useState("");
  const [userLocation, setUserLocation] = useState("");
  const { loading, error, location } = useLocation();
  const [loadingError, setLoadingError] = useState(false);

  const initializationError = () => {
    setStatus("Error: Could not determine coordinates from location.");
    setLoadingError(true);
  };

  // Fetch user location on component load.
  useEffect(() => {
    if (error) {
      setStatus(error);
      setLoadingError(true);
    }
    if (location) {
      location.latitude && location.longitude
        ? setUserLocation(location)
        : initializationError();
      setLoadingError(false);
    }
  }, [location, error]);

  // JSX.
  return (
    <>
      <FullScreenActivityIndicator
        loading={loading}
        text="Fetching Location..."
      />
      {status && (
        <StatusPrompt
          text={status}
          isActive={true}
          statusCleared={() => setStatus("")}
        />
      )}
      {userLocation && <CollectorMap userLocation={userLocation} />}
      {loadingError && (
        <>
          <Logo />
          <ProjectLabel />
          <Copyright />
          <DevModeLabel />
          <SectionHeader text="Location required!" />
          <SectionHeader text="Please check your location settings." />
        </>
      )}
    </>
  );
};

export default Home;
